import React, { useEffect } from 'react';
import DefaultButton from 'components/Utils/NewDefaultButton';
import './style.scss';
import logo from 'assets/img/logo-full-blue.webp';
import { useNavStack } from 'careand-redux/slices/ui/hooks';
import { Stacks } from 'careand-redux/slices/ui/navigation';
import TopBar from 'scenes/HomePatient2/TopBar';
import { useAppSelector } from 'careand-redux/store';
import { useQueryParams } from 'components/Navigation/NavStack';
import EntryView from './view';

const PatientEntry = () => {
  const nav = useNavStack(Stacks.Master);
  const isLoggedIn = useAppSelector((state) => state.authentication.loggedIn);
  const params = useQueryParams() as { link?: string };
  const isLinking = params?.link === 'true';

  useEffect(() => {
    if (isLoggedIn && !isLinking) {
      nav.popTo('/');
    }
  }, []);

  function onLogin() {
    let url = '/login';
    if (isLinking) {
      url += '?link=true';
    }
    nav.push(url);
  }

  function onRegister() {
    nav.push('/register');
  }

  return (
    <EntryView className="entry" topContent={isLoggedIn && <TopBar title="Link Account" />}>
      <img src={logo} alt="Care& Family Health" className="logo" />
      <div className="buttons">
        <DefaultButton name="Sign In" onClick={onLogin} />
        <DefaultButton className="light" name="Create an Account" onClick={onRegister} />
      </div>
    </EntryView>
  );
};

export default PatientEntry;
